<template>
  <div>
    <div class="top-content col-xs-12 io-documents">
      <div class="summary-top-bar">
        <div class="left">
          Client Plan Audit
        </div>
        <div class="right">
          <form method="GET" action="/io/plans">
            <input type="text" name="search" placeholder="Search" v-model="searchQuery">

            <button type="submit" class="btn btn-secondary" v-on:click="onSearch">Search</button>
          </form>
        </div>
        <div style="clear:both"></div>
      </div>
      <table v-if="users.length > 0" class="table table-responsive">
        <tbody>
        <tr v-for="user in users">
          <td>
            <a v-on:click="showReport(user.client_id)" style="cursor:pointer">
              {{ user.first_name + ' ' + user.last_name }}
            </a>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <div v-if="showReportModal" class="io-documents-modal" v-on:click="closeReportModal">
      <section class="modal-body" v-on:click.stop>
        <!-- close -->
        <div class="close" v-on:click="closeReportModal">
          <i class="fa fa-times"></i>
        </div>
        <!-- close -->
        <!-- header -->
        <div class="heading">
          <h1>MO Client plan audit dashboard</h1>
        </div>
        <div class="content" v-if="!reportLoading">
          <div class="top-header-row">
            <div class="color-legend">
              <div class="legend-item">
                <div class="color" v-bind:style="getScoreStyleText('red')"></div>
                <div class="title">Not present</div>
              </div>

              <div class="legend-item">
                <div class="color" v-bind:style="getScoreStyleText('green')"></div>
                <div class="title">Present</div>
              </div>

              <a v-if="countOfErrors <= 3" v-on:click="refreshDataByClient" style="cursor:pointer">
                <strong>Refresh</strong>
              </a>

              <!-- print -->
              <div style="margin-left: 15px">
                <i v-if="printInProcess" class="fa fa-spinner fa-spin"></i>
                <i v-else class="fa fa-print" v-on:click="printPage"></i>
              </div>
              <!-- print -->
            </div>
          </div>
          <div style="clear:both"></div>
          <div v-if="currentReport['plans']">
            <intelliflo-office-plans-report :report="JSON.stringify(currentReport)" :user="getUserName(selectedUser)"></intelliflo-office-plans-report>
          </div>
          <div v-else>
            <p>In process ... <i class="fa fa-spinner fa-spin"></i></p>
          </div>
        </div>
        <div v-else class="content-loading">
          <div class="loader">
            <div class="bar"></div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import IntellifloOfficePlansReportComponent from "./IntellifloOfficePlansReportComponent.vue";
import {printPage} from "../utils/printUtil";

export default {
  components: {IntellifloOfficePlansReportComponent},
  props: ['search'],
  data() {
    return {
      usersLoading: false,
      reportLoading: false,
      users: [],
      searchQuery: '',
      reports: {},
      currentReport: null,
      showReportModal: false,
      showDisclaimer: false,
      selectedUser: null,
      countOfErrors: 0,
      printInProcess: false,
    }
  },
  mounted() {
    let urlParams = this.getHistoryUrlParams(window.location.href);
    if (urlParams.search) {
      let search = urlParams.search;
      this.searchQuery = search;
      this.getUsers(search);
    }
  },
  watch: {
    currentReport: function (val) {
      // console.log(val);
    },
  },
  methods: {
    onSearch() {
      this.setHistoryUrlParams({ search: this.searchQuery });
      this.getUsers(this.searchQuery);
    },
    getUsers(searchQuery = '') {
      if (!this.usersLoading) {
        this.usersLoading = true;
        axios.get('/io/plans/users', {
          params: {
            search: searchQuery,
          }
        }).then(response => {
          this.users = response.data;
        }).catch(error => {
          console.log(error);
        }).finally(() => this.usersLoading = false);
      }
    },
    getUserName(userId) {
      let user = this.users.find(user => user.client_id === userId);

      return user.first_name + ' ' + user.last_name;
    },
    showReport(userId, refresh = 0) {
      this.selectedUser = userId;
      if (!this.reportLoading) {
        this.showReportModal = true;
        if (!this.reports[userId]) {
          this.reportLoading = true;
          return axios.get(`/io/plans/report/${userId}/${refresh}`)
              .then(response => {
                this.reports[userId] = response.data;
                this.currentReport = this.reports[userId];

                if (response.data.in_process ?? false) {
                  setTimeout(() => this.refreshData(), 10000);
                }
              })
              .catch(error => {
                console.log(error);
                this.countOfErrors = this.countOfErrors + 1;
                this.reportLoading = false
              })
              .finally(() => this.reportLoading = false);
        } else {
          this.currentReport = this.reports[userId];
        }

      }
    },
    toggleDisclaimer() {
      this.showDisclaimer = !this.showDisclaimer;
    },
    getHistoryUrlParams: function (url, asObject = true) {
      let paramsString = (url + '?').split('?')[1];

      if (asObject) {
        let params = {};
        paramsString.split('&').forEach(function (pair) {
          pair = (pair + '=').split('=').map(decodeURIComponent);
          if (pair[0].length) {
            params[pair[0]] = pair[1];
          }
        });
        return params;
      }
      return paramsString;
    },
    setHistoryUrlParams: function (params) {
      let urlParamsString = this.getHistoryUrlParams(window.location.href, false);

      Object.keys(params).forEach(function (key) {
        let re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
        let separator = urlParamsString ? (urlParamsString.match(re) ? "&" : "&") : "?";
        urlParamsString = urlParamsString.replace(re, '$1' + key + "=" + params[key] + '$2');
        if (!urlParamsString.match(re)) {
          urlParamsString += separator + key + "=" + params[key];
        }
      });

      history.pushState({ name: 'documents' }, '', '/io/documents?' + urlParamsString);
    },

    getScoreStyleText: function (key) {
      let color = '#DE301D';
      let border = 'transparent';
      if (key === 'yellow') {
        color = '#F1C40F';
      } else if (key === 'green') {
        color = '#2ECC71';
      }

      return {
        backgroundColor: color,
        borderColor: border
      };
    },

    closeReportModal() {
      this.showReportModal = false;
      this.currentReport = null;
      this.selectedUser = null;
    },

    refreshDataByClient() {
      this.currentReport = null;
      this.reportLoading = false;
      this.reports[this.selectedUser] = null
      this.showReport(this.selectedUser, 1);
    },

    refreshData() {
      this.currentReport = null;
      this.reportLoading = false;
      this.reports[this.selectedUser] = null
      this.showReport(this.selectedUser, 0);
    },

    printPage() {
      this.printInProcess = true;
      const url = `/io/plans/report-print/${this.selectedUser}/${this.getUserName(this.selectedUser)}`;
      printPage(url, () => {
        this.printInProcess = false;
      });
    },
  }

}
</script>

<style scoped>
:not(.input-group-btn) > .btn-refresh-data {
  padding: 8px 8px;
  border-radius: 0;
}
.title {
  margin-right: 10px;
}
</style>